<template>
    <div class="task-top-content" :style="{'border-left': '1px solid '+colorChange(taskData.status)}">
        <div class="task-info" @click="showCtask($event)" :class="{'activeBgc': actived == true}">
            <div class="task-left">
                <div class="task-left-info">
                    <div class="task-left-1">
                        <div class="task-name-box">
                            <div class="task-status-content">
                                <div class="task-status-label" v-if="loadingVisible" :style="{'color': statusColor}">
                                    <i class="fa fa-play" aria-hidden="true" v-if="statusShow"></i>
                                    <i class="fa fa-stop" aria-hidden="true" v-else></i>
                                </div>
                                <div class="task-status-label" v-if="!loadingVisible"><i class="el-icon-loading" style="font-size: 12px;color: #fff"></i></div>
                            </div>
                            <div class="task-title-box" v-if="typeof taskData.params.currency_type !== 'undefined'" @click.stop="showChart(taskData.params.currency_type)">
                                <h2 :style="{'color': taskNameColor}" :class="{'active': actived == true}">{{taskData.params.currency_type.toUpperCase()}}</h2>
                            </div>
                            <div class="open-priority-content">
                                <span class="open-priority" :style="{'display': priorityEvent}"><i class="fa fa-arrow-up" aria-hidden="true"></i></span>
                            </div>
                            <div class="task-panel-box" v-if="analisisData">
                                <Panel :panelData="analisisData[taskData.id]"></Panel>
                            </div>
                        </div>

                        <div class="task-right" @click.stop>
                            <el-checkbox v-model="checked" @change="checkboxEvent(taskData.id)"></el-checkbox>
                            <el-dropdown trigger="click">
                                <button class="task-operation" @click.stop="operationEvent(taskData.id, $event)"><i class="el-icon-arrow-down el-icon--right" ></i></button>
                                <el-dropdown-menu slot="dropdown" >
                                    <el-dropdown-item v-if="taskData.status == 2" @click.native="startTask(taskData.id, 4)">停止</el-dropdown-item>
                                    <el-dropdown-item v-else @click.native="startTask(taskData.id, 2)">启动</el-dropdown-item>
                                    <el-dropdown-item v-if="taskData.status == 3" @click.native="startTask(taskData.id, 2)">重启</el-dropdown-item>
                                    <el-dropdown-item v-else @click.native="startTask(taskData.id, 3)">暂停</el-dropdown-item>
                                    <el-dropdown-item v-if="taskData.status == 2" @click.native="closePosition(taskData.id, 1)">平仓</el-dropdown-item>
                                    <el-dropdown-item @click.native="manulClosePosition(taskData.id)">手动平仓</el-dropdown-item>
                                    <el-dropdown-item @click.native="manualOpenPosition(taskData.id)">手动开仓</el-dropdown-item>
                                    <el-dropdown-item @click.native="delTask(taskData.id)">删除</el-dropdown-item>
                                    <el-dropdown-item @click.native="taskConfig(taskData.id, taskData.status)">配置</el-dropdown-item>
                                    <el-dropdown-item @click.native="showTaskDetail(taskData.id)">明细</el-dropdown-item>
                                    <el-dropdown-item @click.native="showTaskTransDetail(taskData.id)">交易详情</el-dropdown-item>
                                    <el-dropdown-item @click.native="addCtask(taskData.id)">添加子任务</el-dropdown-item>
                                    <el-dropdown-item @click.native="copyTask(taskData.id)">复制任务</el-dropdown-item>
                                </el-dropdown-menu>

                                <!-- 手动平仓 -->
                                <el-dialog :visible.sync="closeVisible" class="task-close-dialog">
                                    <div class="ctask-title">
                                        <h2>手动平仓</h2>
                                    </div>
                                    <el-divider></el-divider>
                                    <div class="task-close">
                                        <div class="task-close-item">
                                            <div>
                                                <span>任务id</span>
                                            </div>
                                            <input type="text" v-model="closeTaskId">
                                        </div>
                                        
                                        <div class="task-close-item">
                                            <div>
                                                <span>平仓利润点(%)</span>
                                            </div>
                                            <input type="text" v-model="closeDlt">
                                        </div>
                                        <div class="task-close-item">
                                            <div>
                                                <span>平仓金额</span>
                                            </div>
                                            <input type="text" v-model="closeCount">
                                        </div>
                                        <div class="task-close-item">
                                            <div>
                                                <span>持续时间</span>
                                            </div>
                                            <input type="text" v-model="closeDuration">
                                        </div>
                                        <div class="task-close-item">
                                            <el-checkbox-group v-model="cTaskIdListContent">
                                                <el-checkbox v-for="(item, index) in cTaskIdList" :key="'ctask-'+index"
                                                :label="item">子任务-{{item}}</el-checkbox>
                                            </el-checkbox-group>
                                        </div>
                                    </div>
                                    <el-divider></el-divider>
                                    <span slot="footer">
                                        <el-button @click="closeVisible = false">取消</el-button>
                                        <el-button @click="closeSubmit(taskData.id)">确认</el-button>
                                    </span>
                                </el-dialog>

                                <!-- 手动开仓-->
                                <el-dialog :visible.sync="openVisible" class="task-close-dialog">
                                    <div class="ctask-title">
                                        <h2>手动开仓</h2>
                                    </div>
                                    <el-divider></el-divider>
                                    <div class="task-close">
                                        <div class="task-close-item">
                                            <div>
                                                <span>任务id</span>
                                            </div>
                                            <input type="text" v-model="openTaskId">
                                        </div>
                                        <div class="task-close-item">
                                            <div>
                                                <span>开仓价差</span>
                                            </div>
                                            <input type="text" v-model="openDiffPrice" placeholder="价差：-0.01">
                                        </div>
                                        <div class="task-close-item">
                                            <div>
                                                <span>开仓金额</span>
                                            </div>
                                            <input type="text" v-model="openPrice">
                                        </div>
                                        <div class="task-close-item">
                                            <div>
                                                <span>持续时间</span>
                                            </div>
                                            <input type="text" v-model="openTimer">
                                        </div>
                                        <div class="task-close-item">
                                            <div>
                                                <span>开仓方向</span>
                                            </div>
                                            <div>
                                                <button @click="directSelect('f')" :class="{'task_selected': directValue == 'f'}">正溢价</button>
                                                <button @click="directSelect('r')" :class="{'task_selected': directValue == 'r'}">负溢价</button>
                                            </div>
                                        </div>
                                        <div class="task-close-item">
                                            <el-checkbox-group v-model="openTaskList">
                                                <el-checkbox v-for="(item, index) in cTaskIdList" :key="'ctask-'+index"
                                                :label="item">子任务-{{item}}</el-checkbox>
                                            </el-checkbox-group>
                                        </div>
                                    </div>
                                    <el-divider></el-divider>
                                    <span slot="footer">
                                        <el-button @click="openVisible = false">取消</el-button>
                                        <el-button @click="openSubmit(taskData.id)">确认</el-button>
                                    </span>
                                </el-dialog>

                                <!-- 添加子任务 -->
                                <el-dialog :visible.sync="ctaskVisible">
                                    <div class="ctask-title">
                                        <h2>添加子任务</h2>
                                    </div>
                                    <el-divider></el-divider>
                                    <el-form lable-width="80px" :label-position="'right'">
                                        <el-form-item v-for="(bourse, index) in cTaskApiList" :key="index" :label="index">
                                            <el-select v-model="addCtaskParam[index]" placeholder="请选择API">
                                                <el-option v-for="(api, index1) in bourse" :key="index1" :label="api.name" :value="api.id"></el-option>
                                            </el-select>
                                        </el-form-item>
                                        <el-form-item label="权重">
                                            <el-input v-model="addCtaskParam.weight" class="form-input" placeholder="填写权重"></el-input>
                                        </el-form-item>
                                    </el-form>
                                    <el-divider></el-divider>
                                    <span slot="footer">
                                        <el-button @click="ctaskVisible = false">取消</el-button>
                                        <el-button v-if="taskData.status !== 2" @click="submitCtask(taskData.id)">确认</el-button>
                                    </span>
                                </el-dialog>
                            </el-dropdown>
                        </div>

                    </div>
                    <div class="task-progress">
                        <el-progress :color="'#00cec9'" :stroke-width="6" :show-text="false" :percentage="positionRateCal(taskPosition[taskData.id])"></el-progress> 
                        <span class="specific-position" :style="{'color': positionColor}">{{positionCal(taskPosition[taskData.id], taskData.params.currency_type)}}</span>
                    </div>
                    <div class="task-price-box">
                        <span class="task-avg-price" style="color: #b7b2b2">
                            {{taskPositionData.pri_dis_rate}}% / {{taskPositionData.count_dis}} | <span ref="priceRate" :style="{'color': taskAvgColor(taskPositionData.pro_rate, positionRateCal(taskPosition[taskData.id]))}">{{taskPositionData.pro_rate}}%</span>/{{taskPositionData.pro}}
                        </span>
                        <span class="task-sgy-name" @click.stop="taskConfig(taskData.id, taskData.status)" style="margin-left: 5px;" :class="{'active': actived == true}"><i class="fa fa-link" aria-hidden="true"></i><strong>{{taskData.strategy_name}}</strong></span>
                        <span style="margin-left: 5px;">x {{ctaskLen}}</span>
                    </div>
                    <div class="progress-content">
                        <span class="task-task-name">
                            <span @click.stop="dialogTaskNameVisible = true">{{taskData.name}}-{{taskData.id}}</span>
                        </span>
                        <span>{{taskData.params.a_bourse}}-{{taskData.params.a_transaction_type}}
                            {{taskData.params.b_bourse}}-{{taskData.params.b_transaction_type}}({{typeNameTrans(taskData.params.b_transaction_type)}})
                        </span>
                    </div>
                    <div class="task-run-condition" v-if="analisisData">
                        <span class="position-calculate">{{showTradeInfo}}</span>
                    </div>
                    <div class="task-run-condition" v-else>
                        <span class="position-calculate">0</span>
                    </div>
                </div>
            </div>
        </div>

        <!-- 任务名称修改 -->
        <el-dialog class="task-name-dialog" title="任务名称修改" :visible.sync="dialogTaskNameVisible">
            <el-divider></el-divider>
            <div class="taskname-modify-content">
                <label for="">任务名称： </label>
                <input type="text" v-model="taskName">
            </div>
            <div class="dialog-footer" slot="footer">
                <button @click.stop="dialogTaskNameVisible = false">取消</button>
                <button @click.stop="taskNameBlur(taskData.id)">修改</button>
            </div>
        </el-dialog>
        <transition name="el-fade-in">
            <ol class="ctask-content" v-show="ctaskListVisible" :style="{'width': ctaskWidth + 'px'}">
                <li v-for="(ctask, index) in ctaskArray" :key="'c_'+index">
                    <CtaskInfo :ctaskData="ctask" :tradeType="taskTradeType" :taskId="taskData.id" :currency="taskData.params.currency_type" @positionAbnoral="getAbnormal"></CtaskInfo>
                </li>
            </ol>
        </transition>
    </div>
</template>

<script>
/* eslint-disable */
import CtaskInfo from '@/views/task/Ctask-info.vue'
import { mapState, mapActions } from 'vuex'
import { put, del, post, get } from '@/api/index'
import Panel from '@/components/Task-panel.vue'
import { isPositionInt, numToCStr } from '@/utils/common'
import { resolve } from 'url';

export default {
    data() {
        return {
            timer: null,
            ctaskVisible: false,
            closeVisible: false,
            ctaskArray: [],
            ctaskListVisible: false,
            actived: false,
            fncData: {},
            ctaskLen: '',
            loadingVisible: true,
            checked: false,
            taskName: '',
            taskStatus: '',
            closeParam: {},
            closeTaskId: '',
            closeDlt: -0.01,
            closeCount: 20,
            closeDuration: 1,
            dialogTaskNameVisible: false,
            textColorShow: false,
            positionAbnormal: false,
            bourseObj: {'Okex': 1, '火币': 2},
            cTaskIdList: [],
            cTaskIdListContent: [],
            openVisible: false,

            openTaskId: '',
            openPrice: 20,
            openDiffPrice: '',
            openTimer: 1,
            directValue: 'f',
            openTaskList: [],
        }
    },
    components: {
        CtaskInfo,
        Panel
    },

    props: {
        taskData: Object,
        analisisData: Object,
    },
    mounted() {
        // 清空 taskIdList 列表
        this.$store.commit('createTaskIdList', []);
        this.taskName = this.taskData.name;
        this.taskStatus = this.taskData.status;
    },
    computed: {
        ...mapState([
            'token',
            'cTaskApiList',
            'tradeTypeObj',
            'dialogVisible',
            'addCtaskParam',
            'addTask',
            'id',
            'taskIdList',
            'taskWebSocket',
            'elementSelect',
            'allTaskIdList',
            'taskPosition',
            'taskRunPriceCal',
            'taskBoxSelect',
            'checkAllFlag',
            'currencyNum',
            'taskCopyData',
            'ctaskWidth',
            'taskChangeAble',
            'taskStatusList'
        ]),

        // 计算任务价格
        taskPositionData: function () {
            var this_task_data = this.taskPosition[this.taskData.id];
            var transTypeArr = ['CQ', 'NW', 'CW', 'CS', 'SS'];
            var aType = this.taskData.params.a_transaction_type;
            var bType = this.taskData.params.b_transaction_type;
            var ctask_total_price_l = 0; // 定义初始左边的价格
            var ctask_total_price_r = 0; // 定义初始右边的价格
            var ctask_total_position_l = 0; // 定义初始左边的仓位
            var ctask_total_position_r = 0; // 定义初始右边的仓位
            var total_pro_count = 0;
            var total_pro_rate = 0;
            var total_rate_bottom = 0;
            if (this_task_data) {
                this.ctaskLen = Object.keys(this_task_data).length;
            }
            // 遍历子任务
            for (var i in this_task_data) {
                if (i !== 'fic') {
                    var ctask_data = this_task_data[i];
                    if (ctask_data.hasOwnProperty('f')) {
                        var ctask_price_l = Number(ctask_data['f'][0][1]) / Number(ctask_data['f'][0][0]);
                        var ctask_price_r = Number(ctask_data['f'][1][1]) / Number(ctask_data['f'][1][0])
                        var ctask_position_l = Number(ctask_data['f'][0][1]);
                        var ctask_position_r = Number(ctask_data['f'][1][1]);
                        // 为正向 相加
                        ctask_total_position_l += ctask_position_l; 
                        ctask_total_position_r += ctask_position_r;
                        ctask_total_price_l += ctask_price_l;
                        ctask_total_price_r += ctask_price_r;
                    } else if (ctask_data.hasOwnProperty('r')) {
                        var ctask_price_l = Number(ctask_data['r'][0][1]) / Number(ctask_data['r'][0][0]);
                        var ctask_price_r = Number(ctask_data['r'][1][1]) / Number(ctask_data['r'][1][0]);
                        var ctask_position_l = Number(ctask_data['r'][0][1]);
                        var ctask_position_r = Number(ctask_data['r'][1][1]);
                        // 反向 相减
                        ctask_total_position_l -= ctask_position_l; 
                        ctask_total_position_r -= ctask_position_r;
                        ctask_total_price_l -= ctask_price_l;
                        ctask_total_price_r -= ctask_price_r;
                    }
    
                    // 判断值是否为 undefined
                    if (typeof ctask_data['pro_count'] == 'undefined') {
                        var pro_count = 0;
                    } else {
                        var pro_count = ctask_data['pro_count'];
                    }
                    if (typeof ctask_data['pro_rate'] == 'undefined') {
                        var pro_rate = 0;
                    } else {
                        var pro_rate = ctask_data['pro_rate'];
                    }
    
                    total_pro_count += pro_count;
                    if (Number(pro_rate) == 0 || Number(pro_count) == 0) {
                        // 分母为0
                        total_rate_bottom += 0;
                    } else {
                        if (Number(pro_count) == 0) {
                            total_rate_bottom += 0;
                        } else {// total_count/(count1/pro1 + ...)
                            total_rate_bottom += Number(pro_count)/Number(pro_rate)
                        }
                    }
                };
            }

            // 总利润比 = 总利润/ (子利润1/子利润比1+...)
            if (total_rate_bottom == 0) {
                total_pro_rate = 0
            } else {
                total_pro_rate = total_pro_count / total_rate_bottom
            }

            // 计算 任务价格=(子任务持仓和)/(子任务持仓/子任务价格+子任务2持仓/子任务2价格+..)
            if (ctask_total_price_l !== 0) {
                var task_price_l =  ctask_total_position_l/ctask_total_price_l; 
                var task_l_num = ctask_total_position_l/task_price_l;
            } else {
                var task_price_l = 0;
                var task_l_num = 0;
            }

            if (ctask_total_price_r !== 0) {
                var task_price_r =  ctask_total_position_r/ctask_total_price_r;
                var task_r_num = ctask_total_position_r/task_price_r;
            } else {
                var task_price_r = 0;
                var task_r_num = 0;
            }

            // 数量1 金额l/价格l - 金额r/价格r
            var number_diff = task_l_num - task_r_num;

            var type_index_l = transTypeArr.indexOf(this.typeNumToStr(aType));
            var type_index_r = transTypeArr.indexOf(this.typeNumToStr(bType));
            // 任务价差=(远期-近期)/近期
            if (type_index_l > type_index_r) {// l 为 近， r 为 远
                if (task_price_l !== 0) {
                    var spread = (task_price_r - task_price_l) / task_price_l;
                } else {
                    var spread = 0;
                }
            } else if (type_index_l <= type_index_r) {// l 远；r 近
                if (task_price_r !== 0) {
                    var spread = (task_price_l - task_price_r) / task_price_r;
                } else {
                    var spread = 0;
                }
            }

            // 字符串拼接 价差|数量差/利润比/利润
            if (ctask_total_price_l == 0 || ctask_total_price_r == 0) {
                // 分母为0
                // return 0.0000+' / '+0.0000+' | '+total_pro_rate.toFixed(2)+'%/'+total_pro_count.toFixed(4);
                return {
                    'pri_dis_rate': 0.0000,
                    'count_dis': 0.0000,
                    'pro_rate': total_pro_rate.toFixed(2),
                    'pro': total_pro_count.toFixed(4)
                }
            } else {
                var ctask_str = (spread*100).toFixed(4) + '% / ' + number_diff.toFixed(4)+' | '+(total_pro_rate*100).toFixed(2)+'%/'+total_pro_count.toFixed(4);
                return {
                    'pri_dis_rate': (spread*100).toFixed(4),
                    'count_dis': number_diff.toFixed(4),
                    'pro_rate': (total_pro_rate*100).toFixed(2),
                    'pro': total_pro_count.toFixed(4)
                }
            }
        },

        statusColor: function () {

            var status = '';
            if (this.taskStatusList.hasOwnProperty(this.taskData.id)) {
                status = this.taskStatusList[this.taskData.id];
            }

            // 运行中
            if (status == 2) return '#245E84';
            // 停止
            else if (status == 4 || status == 1 || status == 0) return '#A23D23';
            // 暂停
            else if (status == 3) return '#f7ab59';
        },

        // 状态展示
        statusShow: function() {
            var status = '';
            if (this.taskStatusList.hasOwnProperty(this.taskData.id)) {
                status = this.taskStatusList[this.taskData.id];
            }
            // 运行中
            if (status == 2) return true;
            // 停止
            else if (status == 4 || status == 1 || status == 0 || status == 3) return false;
        }, 

        // 任务名称颜色显示
        taskNameColor: function () {
            var status = this.taskData.status;
            var browserWidth = document.body.clientWidth;
            var showFlag = false;
            
            if (browserWidth <= 403) {
                showFlag = true;
            } else {
                showFlag = false;
            }
            if (showFlag) {
                // 运行中
                if (status == 2) return '#245E84';
                // 停止
                else if (status == 4 || status == 1 || status == 0) return '#A23D23';
                // 暂停
                else if (status == 3) return '#f7ab59';
            }
        },

        // 持仓异常判断
        positionColor: function () {
            if (this.positionAbnormal) return '#8c0202';
            return ''
        },

        // 任务交易类型
        taskTradeType: function () {
            // this.taskData.params
            let trade_type_object = {
                "a_type": numToCStr(this.taskData.params.a_transaction_type, this.currencyNum),
                "b_type": numToCStr(this.taskData.params.b_transaction_type, this.currencyNum)
            }
            return trade_type_object;
        },

        // 任务优先开仓判断
        priorityEvent: function () {
            if (this.taskChangeAble.includes(String(this.taskData.id))) return '';
            return 'none';
        },

        // 暂时交易信息
        showTradeInfo: function () {
            if (this.analisisData) {
                if (this.analisisData[this.taskData.id]) return this.analisisData[this.taskData.id];
                return '0'
            }
        },
    },
    methods: {
        ...mapActions([
            'getTaskList',
            'getCtaskList',
            'getaBourseType',
            'getbBourseType',
            'createTaskSocket',
        ]),
        // 任务状态判断
        statusJudge(status) {
            if (status == 0 || status == 1 || status == 4) return '未运行';
            else if (status == 2) return '运行中';
            else if (status == 3) return '暂停中';
        },

        // 平仓
        closePosition(taskId, operation) {
            if (operation == 1) {
                // 平仓操作
                this.$confirm('是否确认平仓', '提示', {
                    confirmButtonText: '确认',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.startTask(taskId, operation);
                }).catch(() => {
                    
                })
            }
        },

        // 任务启动 停止 暂停 平仓...
        startTask(taskId, operation) {
            var url = this.$baseUrl + '/task/status/update?token='+this.token+'&taskId='+taskId+'&settingStatus='+operation;
            put(url).then(resp => {
                if (resp.code === 200) {
                    if (operation == 2) {// 如果操作为 2(启动)，等待3秒在发起请求
                        this.loadingVisible = false;
                        this.timer = setInterval(() => {// 启动一个定时器，一直发请求指导状态改变停止
                            // this.getTaskList();
                            this.checkStatus(taskId).then(status => {
                                if (status == 2) {
                                    setTimeout(() => {
                                        this.getTaskList();
                                        clearInterval(this.timer);
                                        this.loadingVisible = true;
                                    }, 1000)
                                }
                            });
                        }, 800);
                    } else if (operation == 1) {// 平仓
                        this.$notify.info({
                            message: resp.info,
                            title: '提示',
                            offset: 100
                        })
                    }else {// 停止
                        this.timer = setInterval(() => {
                            this.checkStatus(taskId).then(status => {
                                if (status == 4) {
                                    setTimeout(() => {
                                        this.getTaskList();
                                        clearInterval(this.timer);
                                    }, 1000)
                                }
                            });
                        }, 800);
                    }
                } else {
                    this.$notify.error({
                        message: resp.info,
                        title: '提示',
                        offset: 100
                    });
                    // 请求参数错误，清除定时器
                    if (this.timer !== null) {
                        clearInterval(this.timer);
                    }
                }
            }).catch(error => {
                console.log(error)
            })
        },

        // 删除任务
        delTask(taskId) {
            if (this.taskData.status == 2 || this.taskData.status == 3) {
                // 任务运行中，不能删除
                this.$notify.error({
                    message: '任务正在运行中!',
                    title: '提示',
                    offset: 100
                })
                return;
            }
            this.$confirm('是否删除该任务?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                // 确定后执行的操作
                var url = this.$baseUrl + '/task/delete';
                var param = {
                    'token': this.token,
                    'taskId': taskId
                };

                del(url, param).then(resp => {
                    if (resp.code === 200) {
                        this.delEvent(taskId, '');
                        this.$notify.info({
                            message: '删除成功',
                            title: '提示',
                            offset: 100
                        })
                        setTimeout(() => {
                            this.getTaskList();
                        }, 800)
                    } else {
                        this.$notify.error({
                            message: resp.info,
                            title: '提示',
                            offset: 100
                        })
                    }
                }).catch(error => {
                    console.log(error);
                })
            }).catch(() => {
                // 取消后执行的操作
            })
            
        },

        // 删除时触发事件
        delEvent(taskId, ctaskId) {
            let url = this.$url_CM + '/ts/delstock';
            let form_data = new FormData()
            form_data.append('task_id', taskId);
            form_data.append('cids', ctaskId);
            post(url, form_data).then(resp => {
                console.log(resp);
            })
        },

        // 检测任务状态
        checkStatus(taskId) {
            return new Promise((resolve, reject) => {
                var url = this.$baseUrl + '/task/status/detection';
                var param = {
                    'token': this.token,
                    'taskId': taskId
                };
    
                get(url, param).then(resp => {
                    if (resp.code == 200) {
                        this.taskStatus = resp.data.status;
                        console.log(resp.data)
                        resolve(resp.data.status)
                    }
                })

            })
        },

        // 运行状态的改变
        colorChange(status) {
            // 运行中
            if (status == 2) return '#245e84';
            // 停止
            else if (status == 4 || status == 1 || status == 0) return '#da5634';
            // 暂停
            else if (status == 3) return '#f7ab59';
        },

        // 显示 添加子任务窗口
        addCtask(taskId) {
            this.ctaskVisible = true;
            this.id.taskId = taskId;
            this.getCtaskList();
        },
        // 提交添加子任务
        submitCtask(taskId) {
            var url = this.$baseUrl + '/task/children/add';
            if (this.addCtaskParam.hasOwnProperty('a_bourse') && this.addCtaskParam.hasOwnProperty('b_bourse')) {
                // 两个交易所都有时的API
                var linkApiId = this.addCtaskParam.a_bourse + ',' + this.addCtaskParam.b_bourse;
            } else if (this.addCtaskParam.hasOwnProperty('a_bourse')) {
                // 只有 a_bourse时
                var linkApiId = String(this.addCtaskParam.a_bourse);
            } else if (this.addCtaskParam.hasOwnProperty('b_bourse')) {
                // 只有 b_bourse时
                var linkApiId = String(this.addCtaskParam.b_bourse);
            }
            var param = {
                'token': this.token,
                'taskId': taskId,
                'linkApiId': linkApiId,
                'weight': Number(this.addCtaskParam.weight)
            };
            post(url, JSON.stringify(param)).then(resp => {
                if (resp.code === 200) {
                    this.$notify.info({
                        message: '添加任务成功',
                        title: '提示',
                        offset: 100
                    })
                    // 关闭 窗口
                    this.ctaskVisible = false;
                    this.getCtaskArray();
                } else {
                    this.$notify.error({
                        message: resp.info,
                        title: '提示',
                        offset: 100
                    })
                }
            })
        },
        // 展示子任务
        showCtask(e) {
            // if (e.target !== e.currentTarget) return;
            // 获取子任务列表
            this.getCtaskArray()
            this.actived = !this.actived;
            this.ctaskListVisible = !this.ctaskListVisible;
        },
        // 获取子任务列表
        getCtaskArray() {
            var url = this.$baseUrl + '/task/children/list';
            var param = {
                'token': this.token,
                'taskId': this.taskData.id
            };

            get(url, param).then(resp => {
                if (resp.code == 200) {
                    this.ctaskLen = Object.keys(resp.data).length;
                    this.ctaskArray = resp.data;
                } else {
                    this.$notify.error({
                        message: resp.info,
                        title: '提示',
                        offset: 100
                    })
                }
            })
        },

        // 主任务配置
        taskConfig(taskId, status) {
            var url = this.$baseUrl + '/task/params/get';
            var param = {
                'token': this.token,
                'taskId': taskId
            };
            this.$store.commit('initAddTaskObj', {});
            this.$store.commit('initTaskConfigParam', {});
            get(url, param).then(resp => {
                if (resp.code === 200) {
                    this.$store.commit('initTaskConfigParam', resp.data);
                    var data = resp.data;
                    for (var i in data.taskBaseParams) {// 任务基本参数遍历
                        this.addTask[i] = String(data.taskBaseParams[i])
                        if (i == 'a_bourse') {// 如果有 a_bourse, 获取交易类型
                            this.getaBourseType();
                        } 
                        if (i == 'b_bourse') {// 如果有 b_bourse, 获取交易类型
                            this.getbBourseType();
                        }
                    }
                    for (var i in data.strategyParams) {
                        // 遍历策略参数
                        this.addTask[i] = data.strategyParams[i];
                    }
                    for (var i in data.debitCreditParams) {
                        // 遍历交易和借贷参数
                        this.addTask[i] = data.debitCreditParams[i];
                    }
                    this.id.taskId = taskId;
                    
                    // 显示 配置参数弹窗
                    this.$parent.$parent.$parent.showAddTask('config', status, this.taskData.strategy_name);

                } else {
                    this.$notify.error({
                        message: resp.info,
                        title: '提示',
                        offset: 100
                    })
                }
            })
        },

        // 交易价格位数保留
        judgeNum(num) {
            return num.toFixed(4);
        },
        // 交易额位数保留
        tradeNum(num) {
            return Math.round(num);
        },

        // 显示任务明细
        showTaskDetail(taskId) {
            let taskDetail = this.$router.resolve({
                name: 'TaskDetail',
                query: {
                    id: taskId
                }
            })

            window.open(taskDetail.href, '_blank')
        },

        // 显示交易详情
        showTaskTransDetail(taskId) {
            let transDetailInfo = this.$router.resolve({
                name: 'TaskTradeInfo',
                query: {
                    id: taskId,
                    type: 'task'
                }
            })

            window.open(transDetailInfo.href, '_blank');
        },

        // 点击操作触发事件
        operationEvent(taskId, e) {
            if (typeof this.elementSelect !== 'undefined') {
                $(this.elementSelect).css('color', '#97979a');
            }
            this.$store.commit('giveElementNode', e.srcElement);
            $(this.elementSelect).css('color', '#fff');
        },

        // 主任务持仓计算
        positionRateCal(data) {
            if (data) {
                if (data.hasOwnProperty('fic')) {
                    // data 对象如果有 fic 则删除
                    delete data.fic
                }
                if (JSON.stringify(data) == '{}') return 0;
                var real_position = 0,
                    target_position_0 = 0,
                    target_position_1 = 0; 
                for (var i in data) {// 遍历主任务下的子任务
                    var inerData = data[i];
                    if (data[i].hasOwnProperty('mt')) {
                        // 判断 data[i] 里是否有 mt ，有则计算
                        target_position_0 += inerData['mt'][0];
                        target_position_1 += inerData['mt'][1];
                        let currency_name = this.taskData.params.currency_type;
                        if (data[i].hasOwnProperty('r')) {
                            let result = isPositionInt(inerData['r'][0][1], inerData['r'][1][1], currency_name);
                            real_position += result.data;
                        } else if (inerData.hasOwnProperty('f')) {
                            let result = isPositionInt(inerData['f'][0][1], inerData['f'][1][1], currency_name);
                            real_position += result.data;
                        }                    
                    }
                }
                if (target_position_1 == 0 && target_position_0 == 0) return 0;
                var finall_position = Math.round((real_position/(Number(target_position_0) + Number(target_position_1)))*100);
                if (finall_position > 100) return 100;
                else if (finall_position < 0) return 0;
                return finall_position;
            }
        },

        // 具体持仓显示
        positionCal(data, currency) {
            if (typeof data !== 'undefined') {
                if (data.hasOwnProperty('fic')) {
                    // data 对象如果有 fic 则删除
                    delete data.fic
                }
                if (JSON.stringify(data) == '{}') return 0;
                var real_position = 0,
                    target_position_0 = 0,
                    target_position_1 = 0;                    
                for (var i in data) {
                    var inerData = data[i];
                    if (data[i].hasOwnProperty('mt')) {
                        // 判断 data[i] 里是否有 mt ，有则计算
                        // target_position += inerData['mt'];
                        target_position_0 += inerData['mt'][0];
                        target_position_1 += inerData['mt'][1];
                        if (data[i].hasOwnProperty('r')) {
                            real_position += inerData['r'][0][1];
                        } else if (inerData.hasOwnProperty('f')) {
                            real_position += inerData['f'][0][1];
                        }
                    }
                }
                if (currency == 'BTC') {
                    // 如果 btc 除 100
                    return Math.round(real_position/100) + '/(' + Math.round(target_position_0/100) +'+'+Math.round(target_position_1/100)+')';
                } else {
                    // 其他的 则 除 10
                    return Math.round(real_position/10) + '/(' + Math.round(target_position_0/10) +'+'+Math.round(target_position_1/10)+')';
                }
            }  
        },

        // 多选 选择事件
        checkboxEvent(taskId) {
            if (this.checked == true) {
                this.taskBoxSelect.push(taskId);
            } else {
                if (this.taskBoxSelect.includes(taskId)) {
                    var task_index = this.taskBoxSelect.indexOf(taskId);    
                    this.taskBoxSelect.splice(task_index, 1);
                }
            }
        },

        // 任务名字修改事件
        taskNameBlur(id) {
            var param = {
                'token': this.token,
                'taskId': id,
                'name': this.taskName
            };
            var url = this.$baseUrl + '/task/name/update';
            if (this.taskName !== this.taskData.name) {// 名字发生变化时才发送请求
                put(url, JSON.stringify(param)).then(resp => {
                    if (resp.code == 200) {
                        this.$notify.info({
                            message: '修改任务名字成功!',
                            title: '提示',
                            duration: 1000,
                            offset: 100
                        })
                        this.dialogTaskNameVisible = false;
                        this.getCtaskArray();
                    } else {
                        this.$notify.error({
                            message: resp.info,
                            title: '提示',
                            duration: 1000,
                            offset: 100
                        })
                    }
                })
            }
        },

        // 全部选中 or 全部取消事件
        allCheckedEvent() {
            this.checked = this.checkAllFlag;
        },
        // 手动平仓弹窗
        manulClosePosition(id) {
            this.getCtaskId(id).then(data => {
                this.closeTaskId = id;
                this.closeVisible = true;
                this.cTaskIdList = data;
                let price_node = this.$refs.priceRate.textContent;
                this.closeDlt = price_node.slice(0, price_node.length-1)
            });
        },

        // 手动平仓提交
        closeSubmit(taskId) {
            var url = this.$url_CM + '/taskServer/manual';
            var paramObj = {
                'dlt': this.closeDlt/100,
                'count': this.closeCount,
                'duration': this.closeDuration,
                'cid': this.cTaskIdListContent,
                'change_type': 'close'
            };
            if (this.cTaskIdListContent.length == 0) return;
            var form_data = new FormData();
            form_data.append('task_id', taskId);
            form_data.append('cparam', JSON.stringify(paramObj));
            // post form-data 格式
            post(url, form_data).then(resp => {
                this.$notify.info({
                    message: resp,
                    title: '提示',
                    offset: 100,
                    duration: 1000
                })
                this.closeVisible = false;
            })
        },

        // 手动开仓提交
        openSubmit(taskId) {
            let url = this.$url_CM + '/taskServer/manual';
            let param = {
                'dlt': this.openDiffPrice,
                'count': this.openPrice,
                'duration': this.openTimer,
                'cid': this.openTaskList,
                'change_type': 'open',
                'direct': this.directValue
            };
            if (this.openTaskList.length == 0) return;
            let formData = new FormData();
            formData.append('task_id', taskId);
            formData.append('cparam', JSON.stringify(param));
            post(url, formData).then(resp => {
                this.$notify.info({
                    message: resp,
                    title: '提示',
                    offset: 100,
                    duration: 1000
                })
                this.openVisible = false;
            })
        },

        // 展示图表
        showChart(currency) {
            var aType = this.typeNumToStr(this.taskData.params.a_transaction_type);
            var bType = this.typeNumToStr(this.taskData.params.b_transaction_type);
            var aCurrency = this.stringTogether(currency, aType, 'a');
            var bCurrency = this.stringTogether(currency, bType, 'b');
            var aBourse = this.bourseObj[this.taskData.params.a_bourse];
            var bBourse = this.bourseObj[this.taskData.params.b_bourse];
            var paramObj = {
                'startTime': this.taskData.createtime,
                'aCurrency': aCurrency,
                'bCurrency': bCurrency,
                'aType': aType,
                'bType': bType,
                'aBourse': aBourse,
                'bBourse': bBourse
            };
            this.$emit('showChartEvent', paramObj);
        },

        // 区分现货及字符串拼接
        stringTogether(currency, type, name) {
            if (type == 'SS') {// 当交易类型为现货时
                return currency.toLowerCase() + '_usdt';
            } else {// 当交易类型不为现货时
                return currency.toLowerCase() + '_usd';
            }
        },

        // 交易数字字符串转换为 字母
        typeNumToStr(type) {
            if (type == '现货') return 'SS';
            else if (type == '永续') return 'CS';
            else {
                for (var i in this.currencyNum) {
                    if (type == this.currencyNum[i]) {
                        return i;
                    }
                }
            }
        },

        // 任务复制
        copyTask() {
            var url = this.$baseUrl + '/task/params/get';
            var param = {
                'token': this.token,
                'taskId': this.taskData.id
            };

            get(url, param).then(resp => {
                if (resp.code === 200) {
                    // console.log(resp.data, this.taskData);
                    var new_param = {
                        'taskData': this.taskData,
                        'baseData': resp.data    
                    }
                    this.$store.commit('setTaskCopyData', new_param);
                    this.taskCopyData['addFlag'] = 'copy';
                    this.$parent.$parent.$parent.showAddTask('add', this.taskData.status, this.taskData.strategy_name);
                } else {
                    this.$notify.error({
                        message: resp.info,
                        title: '提示',
                        offset: 100,
                        duration: 1000
                    })
                }
            })
        },

        // 任务平均价格颜色判断
        taskAvgColor(param, position) {
            if(param) {
                // console.log(position, typeof position)
                if (position == 0) return '#b7b2b2';
                if (param == '0.00') return '#b7b2b2';
                else if (!param.includes('-')) return '#f8ac59';
                return '#b7b2b2';
            }
        },

        // 获取持仓异常信息
        getAbnormal(data) {
            this.positionAbnormal = data
        },

        // 获取子任务id
        getCtaskId(taskId) {
            return new Promise((resolve, reject) => {
                let url = this.$baseUrl + '/task/children/list';
                let param = {
                    'token': this.token,
                    'taskId': taskId
                };
    
                get(url, param).then(resp => {
                    if (resp.code == 200) {
                        let c_data = resp.data;
                        let c_task_id_list = [];
                        for (let i=0; i<c_data.length; i++) {
                            c_task_id_list.push(String(c_data[i].task_children_id));
                        }
                        resolve(c_task_id_list);
                    }
                })
            })
        },

        // 手动开仓事件
        manualOpenPosition(taskId) {
            this.getCtaskId(taskId).then(data => {
                this.openVisible = true;
                this.openTaskId = taskId;
                this.cTaskIdList = data;
            });
        },

        // 开仓方向选择
        directSelect(data) {
            this.directValue = data;
        },

        // 交易类型名字转换
        typeNameTrans(type) {
            if (JSON.stringify(this.currencyNum) !== '{}') {
                let zh_type = numToCStr(type, this.currencyNum)
                return zh_type;
            }
        },
    }
}
</script>

<style lang="scss">
    body{
        .el-dropdown-menu{
            .el-dropdown-menu__item{
                line-height: 25px !important;
            }
        }
    }
    #name-pop{
        width: 200px !important;
    }
    .el-popover{
        .taskname-modify-content{
            display: flex;
            justify-content: flex-start;
            justify-content: center;
            input{
                margin-left: 5px;
            }
            button{
                margin-left: 10px;
                outline: none;
                padding: 0 4px;
                background-color: #363a3c;
                border: 1px solid #363a3c;
                color: #97979a;
            }
        }
    }
    // 激活时的背景颜色 
    .activeBgc{
        background-color: #1e1e1e !important;
    }
    .task_selected {
        border: 2px solid #1AB394 !important;
        color: #1AB394;
        // box-shadow: 0 0 2px #1AB394;
        // outline-color: #1AB394;
    }
    .task-top-content{
        padding: 2px;
        margin-bottom: 10px;
    }
    .task-name-dialog{
        .el-dialog{
            box-shadow: 0 0 5px #fff;
            background-color: #1e1e1e !important;
            .el-dialog__header{
                padding: 10px !important;
                text-align: center;
                font-weight: 600;
                background-color: #1e1e1e !important;
                .el-dialog__title{
                    color: #7b7b80;
                }
            }
            .el-dialog__body{
                .el-divider{
                    margin: 12px 0;
                    background-color: #5a5858;
                }
                .taskname-modify-content{
                    display: flex;
                    justify-content: center;
                    input{
                        margin-left: 10px;
                        outline: none;
                        border-radius: 3px;
                        border: 1px solid #2a2d2e;
                        padding: 3px;
                        color: #7b7b80;
                        background-color: #2a2d2e;
                    }
                }
            }
            .el-dialog__footer{
                padding-bottom: 10px;
                padding-top: 0;
                .dialog-footer{
                    button{
                        padding: 2px 8px;
                        margin-left: 5px;
                        background-color: #2a2d2e;
                        border: 1px solid #2a2d2e;
                        border-radius: 3px;
                        color: #97979a;
                    }
                    button:hover{
                        cursor: pointer;
                        background-color: #3e4142;
                    }
                }
            }
        }
    }

    .task-info{
        display: flex;
        // justify-content: space-between;
        padding: 10px 0 10px 10px;
        color: #59595a;
        border-radius: 3px;
        background-color: #262829;
        .task-left{
            display: flex;
            justify-content: space-between;
            width: 100%;
            .task-status-content{
                display: flex;
                align-items: center;
                .task-status-label{
                    margin-right: 5px;
                }
            }
            .task-title-box{
                padding: 0 3px;
                display: flex;
                align-items: center;
                // margin-right: 5px;
                min-width: 80px;
                h2{
                    font-family: Impact, Haettenschweiler, 'Arial Narrow Bold', sans-serif;
                    font-size: 48px;
                    color: #888888;
                }
            }
            .task-title-box:hover{
                cursor: pointer;
                h2{
                    color: #c0c0c2;
                }
            }
            .open-priority {
                i {
                    color: #db5634;
                }
            }
            .task-panel-box{
                display: flex;
                align-items: center;
                margin-right: 5px;
            }
            .task-left-info{
                // padding: 10px 0; 
                display: flex;
                flex-direction: column;
                width: 100%;
                .task-left-1{
                    display: flex;
                    justify-content: space-between;
                    line-height: 25px;
                }
                .task-name-box{
                    display: flex;
                    justify-content: flex-start;
                }
                .task-progress{
                    width: 100%;
                    display: flex;
                    justify-content: flex-start;
                    flex-wrap: wrap;
                    flex: 1;
                    margin-left: 18px;
                    .specific-position{
                        font-size: 12px;
                        margin-left: 5px;
                        line-height: 12px;
                        color: rgb(183, 178, 178);;
                    }
                    .el-progress{
                        width: 200px;
                        text-align: left;
                    }
                    .el-progress__text{
                        font-size: 12px !important;
                    }
                    .el-progress-bar{
                        display: inline-table;
                    }
                    .el-progress-bar__outer{
                        background-color: #58595a;
                    }
                    .el-progress-bar__innerText{
                        display: block !important;
                    }
                    span{
                        margin-left: 10px;
                    }
                }
                .task-price-box{
                    text-align: left;
                    margin-left: 18px;
                    .task-sgy-name:hover{
                        cursor: pointer;
                        color:#c0c0c2;
                    }
                }
                .progress-content{
                    font-size: 12px;
                    text-align: left;
                    flex: 1;
                    margin-left: 18px;
                    .task-task-name{
                        span:hover{
                            cursor: pointer;
                            color: #7b7b80; 
                        }
                    }
                    span{
                        padding: 2px 0;
                        margin-right: 5px;
                        .task-name-input{
                            outline: none;
                            border: 1px solid #262829;
                            background-color: #262829;
                            color: #59595a;
                        }
                    }
                    
                }
                .task-run-condition{
                    text-align: left;
                    flex: 1;
                    margin-left: 18px;
                }
            }
            .position-calculate{
                font-size: 12px;
            }
            .fa-level-down{
                color: #1AB394;
            }
            .fa-level-up{
                color: #da5634;
            }
            
            .task-left-price{
                font-size: 12px;
                padding: 10px;
                display: table;
                vertical-align: middle;
                line-height: 32px;
                span{
                    margin-right: 10px;
                }
            }
            .progress-position{
                span{
                    font-size: 12px;
                    font-weight: 400;
                    float: left;
                }
            }
        }
        .task-right{
            padding: 0 10px;
            display: flex;
            margin: auto 0;
            .el-checkbox{
                margin-right: 10px;
                .el-checkbox__inner{
                    background-color: #2a2d2e;
                    border-color: #2a2d2e;
                }
            }
            label{
                // background-color: #db5634;
                padding: 5px 10px;
                font-size: 12px;
                color: #FFF;
                border-radius: 3px;
                margin-right: 10px;
            }
            .el-dropdown{
                .task-operation{
                    background-color: #2a2d2e;
                    border-color: #2a2d2e;
                    padding: 4px;
                    width: 50px;
                    color: #97979a;
                    border: 1px solid #1e1e1e;
                    box-shadow: 0 0 10px #1e1e1e;
                    outline: none;
                    border-radius: 3px;
                    transition: width 0.5s;
                    -webkit-transition: width 0.5s;
                    i{
                        margin-left: 0;
                    }
                }
                .task-operation:hover{
                    cursor: pointer;
                    
                }
                .task-operation:focus{
                    color: #fff;
                }
                .el-form{
                    width: 80%;
                    margin: 0 auto;
                    padding: 10px;
                    .el-form-item__label{
                        text-align: right;
                        color: #97979a;
                        min-width: 90px;
                    }
                    .el-form-item__content{
                        text-align: left;
                        .form-input{
                            width: 55%;
                        }
                        
                    }
                }
                .task-close-dialog{
                    .task-close{
                        width: 30%;
                        min-width: 300px;
                        margin: auto;
                        .task-close-item{
                            display: flex;
                            justify-content: space-between;
                            padding: 5px;
                            div{
                                min-width: 70px;
                                margin-right: 10px;
                                button {
                                    padding: 2px 10px;
                                    margin-right: 10px;
                                    border-radius: 2px;
                                    border: 1px solid #97979a;
                                    background-color: #fff;
                                    outline: none;
                                }
                                button:hover {
                                    cursor: pointer;
                                    background-color: #DCDFE6;
                                    // color: blue;
                                }
                            }
                            input{
                                outline: none;
                                // flex: 1;
                                border: 1px solid #97979a;
                                border-radius: 3px;
                                padding: 3px;
                                caret-color: #97979a;
                                color: #97979a;
                            }

                            .el-checkbox-group {
                                display: flex;
                                flex-flow: column;
                                .el-checkbox {
                                    color: #000;
                                    .el-checkbox__input {
                                        color: #000;
                                    }
                                }
                            }
                        }
                    }
                }
                .task-open-dialog {
                    .task-open {
                        .task-open-item{
                            display: flex;
                            justify-content: center;
                            padding: 5px;
                            div{
                                min-width: 70px;
                                margin-right: 10px;
                            }
                            input{
                                outline: none;
                                border: 1px solid #97979a;
                                border-radius: 3px;
                                padding: 3px;
                                caret-color: #97979a;
                                color: #97979a;
                            }

                            .el-checkbox-group {
                                .el-checkbox {
                                    color: #000;
                                    .el-checkbox__input {
                                        color: #000;
                                    }
                                }
                            }
                        }
                    }
                }
                .el-dialog{
                    .ctask-title{
                        padding-top: 10px;
                    }
                    .el-dialog__footer{
                        .el-button{
                            span{
                                padding: 5px;
                            }
                        }
                    }
                }
            }
        }
        // 激活时的颜色 
        .active{
            color: #da5634;
        }
    }
    .task-info:hover{
        background-color: #1e1e1e;
    }
    .ctask-content{
        margin: 0 0 10px 0;
        position: absolute;
        z-index: 1000;
        width: 23.2%;
        box-shadow: 0px 0px 5px #245e84;
        background-color: #000;
        li{
            background-color: #1e1e1e;
            padding: 5px;
            margin: 3px 0;
            box-shadow: 0px 0px 5px #245e84;
        }
        li:hover{
            background-color: #1E1E1E;
        }
    }

</style>
